import { Tooltip } from '@ipfabric/ui-components/Tooltip/Tooltip';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';

export const GraphNetworkViewerNoValueIcon: FC = () => {
  const msg = useLocale();

  return (
    <Tooltip
      content={
        msg.canvasGraph.graphSidePanel.networkViewerDataInput.noValueIconTooltip
      }
    >
      <i className='fa fa-info-circle fa-fw ml-lgu-2' />
    </Tooltip>
  );
};
